<template>
    <div :class="{'row': multiColumn, 'w-100': !multiColumn}">
        <div :class="{'col-md-6': multiColumn}">
            <assignee :lead="form" :updateable="!(form.status && form.status.finished) && editable"
                      @selected="selectedAssignee" @updated="updated"></assignee>
        </div>

        <div v-if="form.source" :class="{'col-md-6': multiColumn}">
            <strong>Bron:</strong>
            <a :href="form.url" target="_blank" class="card source mb-3">
                <div class="card-body d-flex justify-content-between">
                    <div>
                        <div class="card-text">
                            <div class="dot" :style="{'background': form.source.color}"></div>
                            {{form.source.name}}
                        </div>
                        <small class="card-text text-muted">{{moment(form.created_at).format('L LT')}}
                            <template v-if="form.creator"> door {{form.creator.name}}</template>
                        </small>
                    </div>
                    <em v-if="form.url" class="fa fa-external-link-alt text-muted"></em>
                </div>
            </a>
        </div>

        <div v-if="askMessage" :class="{'col-md-6': multiColumn}">
            <strong>Bericht:</strong>
            <b-form-textarea id="message" v-model="form.values.message" placeholder="Optioneel" rows="6" max-rows="55"></b-form-textarea>
        </div>

        <formdata-display v-if="!askMessage" v-for="(value, key) in fields" :key="key" :formKey="key" :value="value"
                          :newline="true" :multiColumn="multiColumn"></formdata-display>

        <a class="btn btn-light btn-sm" :for="'form-view-'+this.form.id" v-b-modal="'form-view-' + form.id"
           v-if="onlyImportant && !askMessage" v-shortkey="{openAllFieldsModel: ['a']}" @shortkey="keyDown">
            Alle velden bekijken <i class="ml-1 fas fa-bolt"></i>
        </a>

        <b-card v-if="form.mail && form.mail['attachment-count']" class="mt-3" no-body header="Bijlages">
            <b-list-group flush>
                <b-list-group-item v-for="(attachment, index) in form.mail.attachments"
                                   :key="'attachment' + form.id + '-' + index" @click="saveAttachment(attachment.name)"
                                   :class="{'whirl ringed': downloadingAttachment(attachment.name)}" button>
                    <div class="d-flex justify-content-between align-middle">
                        <span>
                            {{attachment.name}} <small>({{attachment.size | prettyBytes}})</small>
                        </span>
                        <i class="fas fa-download align-self-center"></i>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </b-card>

        <b-modal
                @hidden="$root.modelOpen = false"
                :no-close-on-backdrop="true"
                :lazy="true"
                :ref="'form-view-' + form.id"
                :id="'form-view-' + form.id"
                title="Ontvangen formulier"
                size="xl"
                v-if="onlyImportant"
                scrollable>
            <div>
                <formdata :editable="editable" :form="form" :multiColumn="true" @updated="updated"></formdata>
            </div>
            <div slot="modal-footer" class="w-100">
                <button class="btn btn-light float-right" @click="hideFormDetails">
                    Sluiten
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import formKeys from './../helpers/formKeys';
    import Assignee from "./leads/assignee";
    import FileSaver from 'file-saver';

    export default {
        components: {
            Assignee
        },
        props: {
            multiColumn: {
                type: Boolean,
                default: false
            },
            onlyImportant: {
                type: Boolean,
                default: false
            },
            askMessage: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                required: true,
            },
            editable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                importantFieldsData: null,
                downloading: {}
            }
        },
        watch: {},
        beforeDestroy() {
            if (this.readTimeout !== null) {
                clearTimeout(this.readTimeout);
            }
        },
        mounted() {
        },
        computed: {
            importantFields() {
                this.importantFieldsData = formKeys.findRelevantData(this.form.values);
                return this.importantFieldsData;
            },
            fields() {
                if (this.onlyImportant) {
                    return this.importantFields;
                }
                return this.form.values;
            }
        },
        methods: {
            downloadingAttachment(name) {
                if (!this.downloading.hasOwnProperty(name)) {
                    this.downloading[name] = false;
                }
                return this.downloading[name];
            },
            saveAttachment(name) {
                if (!this.form || this.downloadingAttachment(name)) {
                    return;
                }
                this.downloading[name] = true;
                this.errors = [];
                axios({
                    url: '/api/v1/leads/mail/' + this.form.mail_id + '/attachment/' + name, method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        this.downloading[name] = false;

                        FileSaver.saveAs(new Blob([response.data], {type: response.headers['content-type']}), name);

                    })
                    .catch(error => {
                        this.downloading[name] = false;
                        this.errors = ['Something went wrong. Please try again.'];
                    });
            },
            mappedKey(key) {
                return formKeys.mapKey(key, key);
            },
            hideFormDetails() {
                this.$refs['form-view-' + this.form.id].hide();
            },
            shouldShow(key) {
                return formKeys.shouldShow(key);
            },
            updated(data) {
                this.$emit('updated', data);
            },
            selectedAssignee(data) {
                let tmpEvent = Object.assign({}, this.form);
                tmpEvent.assignee_id = data.id;
                tmpEvent.assignee = data;
                this.$emit('updated', tmpEvent);
            },
            keyDown(event) {
                switch (event.srcKey) {
                    case 'openAllFieldsModel':
                        this.$refs[event.target.attributes.for.value].show();
                        this.$root.modelOpen = event.target.attributes.for.value;
                    break;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn .fas {
        vertical-align: middle;
    }

    .source {
        color: #212529;
        max-width: 360px;
        text-decoration: none;
        .card-body {
            padding: 0.8rem;
        }
        &:not([href]):not([tabindex]) {
            cursor: default;
        }
        &:has([href]), &:has([tabindex]) {
            &:hover {
                text-decoration: none;
                box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.2);
            }
            &:active {
                text-decoration: none;
                box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.4);
            }
        }
    }
</style>